import React, { useEffect, useState } from 'react';
import {
    Button,
    Card,
    Chip,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Paper,
    Typography,
} from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { PersonalJourneyClasses } from '../../../styles/PersonalJourneyClasses';
import CVManager from './CVManager';
import CoverLetterManager from './CoverLetterManager';
import SearchIcon from '@mui/icons-material/Search';
import OtherFiles from './OtherFiles';
import { CyanButton } from '../../CyanButton';
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import JHApi from "../../../utils/JHApi"
import clsx from 'clsx';
import ReactGA from 'react-ga4'
import SparklesIcon from '../../../assets/svgs/SparklesIcon';
//import AIAssistants from './AIAssistants';

const useStyles = makeStyles((theme) => ({
    root: {
        borderRadius: 20,
        overflow: "hidden",
        direction: "rtl",
        background: '#ececec',
        maxWidth: 920,
        boxShadow: '0px 2px 1px -1px #6366f1, 0px 1px 1px 0px #6366f1, 0px 1px 3px 0px #6366f1 !important',
        marginBottom: '16px !important',
        marginTop: '62px !important',
        [theme.breakpoints.up('sm')]: {
            display: 'flex',
            margin: 'auto',
        },
        [theme.breakpoints.down('md')]: {
            padding: 24,
            paddingTop: 32
        },
    },
    planHeader: {
        [theme.breakpoints.down('md')]: {
            textAlign: 'center'
        },
    },
    planSection: {
        [theme.breakpoints.up('sm')]: {
            padding: theme.spacing(3),
        },
    },
    planList: {
        [theme.breakpoints.up('sm')]: {
            background: '#fff'//"#e8d5f0",
        },
    },
    item: {
      display: "flex",
      alignItems: "flex-start",
      marginBottom: theme.spacing(1.5),
    },
    icon: {
      marginLeft: theme.spacing(1),
      marginTop: 4,
      fontSize: 16,
    },
    check: {
      color: "#0000008a",
    },
    close: {
      color: "#f44336",
    },
    price: {
      fontSize: 32,
      fontWeight: "bold",
      margin: theme.spacing(2, 0),
      textAlign: 'center'
    },
    button: {
        backgroundColor: '#aa4dc8',
        color: '#fff',
        fontSize: 16,
        lineHeight: '24px',
        borderRadius: 18,
        padding: '5px 24px',
        letterSpacing: '1px',
        fontWeight: 700,
        marginBottom: 24,
        "&:hover": {
            backgroundColor: '#cd68ed'
        },
    },
    title: {
      fontWeight: "bold",
      fontSize: 20,
      marginBottom: theme.spacing(1),
    },
}));

const FeatureItem = (props) => {
    const classes = useStyles();
  
    return (
        <div className={classes.item}>
            {props.notIncluded ? (
                <CloseIcon className={`${classes.icon} ${classes.close}`} />
            ) : (
                <CheckIcon className={`${classes.icon} ${classes.check}`} />
            )}
            <Typography style={{fontSize: 16}} variant="body2">{props.children}</Typography>
        </div>
    );
};

function PricingCard() {
    const [showTems, setShowTems] = useState(false);
    const [terms, setTerms] = useState('');

    useEffect(() => {
        JHApi.getTerms({},(response)=>{
            setTerms(response)
        }, (error) => {
            
        })
    }, []);

    const handleCloseTerms = () => {
        setShowTems(false)
    }
    
    const classes = useStyles()

    return (
        <>
            <Dialog onClose={handleCloseTerms} open={showTems} maxWidth='lg'>
                <DialogTitle style={{textAlign: 'right', direction: 'rtl'}}>תנאי שירות JobHunt</DialogTitle>
                <DialogContent dividers>
                    <div style={{textAlign: 'right', direction: 'rtl'}} dangerouslySetInnerHTML={{__html: terms}} />
                </DialogContent>
                <DialogActions>
                    <Button onClick={()=>ReactGA.event({category: `Journey`, action: `payment_link_files`})} variant="contained" target='_blank' href="https://buy.stripe.com/bJedR9c9cfQU05wgWg33W0e" color="primary" aria-label="קראתי ואני מאשר את תנאי השירות">
                        קראתי ואני מאשר את תנאי השירות
                    </Button>
                </DialogActions>
            </Dialog>

            <Card className={classes.root}>
                <div className={classes.planSection}>
                    <div className={classes.planHeader}>
                        <Typography className={classes.title}>JobHunt Files</Typography>
                        <Typography variant="body2" style={{fontSize: 16}}>עריכת קבצים אישית עם מומחה קריירה</Typography>
                    </div>
                    <div style={{textAlign: 'center'}}>
                        <Typography className={classes.price}>₪1,860</Typography>
                        <Button variant="contained" color='primary' style={{marginBottom: 24}} 
                            onClick={()=>{
                                ReactGA.event({category: `Journey`, action: `open_terms_files`})
                                setShowTems(true)
                            }}
                        >
                            רישום לתוכנית
                        </Button>
                    </div>
                </div>

                <div className={clsx(classes.planList, classes.planSection)}>
                    <Typography className={classes.title}>השירות כולל:</Typography>
        
                    <FeatureItem><b>3 פגישות עומק</b> עם מומחה קריירה</FeatureItem>
                    <FeatureItem>בניה או שכתוב של קורות החיים (בעברית או באנגלית)</FeatureItem>
                    <FeatureItem>ניסוח מכתב מקדים</FeatureItem>
                    <FeatureItem>התאמת פרופיל לינקדאין</FeatureItem>
                    <FeatureItem>סימולציית ראיון עבודה, חידוד מסרים מקצועיים והצעת ערך</FeatureItem>
                </div>
            
                <div className={clsx(classes.planList, classes.planSection)}>    
                    <FeatureItem>גישה חלקית למערכת ניהול חיפוש עבודה <b>JobHunt Journey</b></FeatureItem>
                    <FeatureItem>שירות בעברית ובאנגלית לשיפור מיומנויות השפה</FeatureItem>
                    <FeatureItem>ניתן לשדרג למסלולים השונים בתשלום ההפרש</FeatureItem>
                    <FeatureItem>עד <u>שלושה שבועות</u> לקבלת הקבצים המלאים</FeatureItem>
                    <FeatureItem notIncluded={true}>לא כולל פרסום ברשת אנשי הקשר</FeatureItem>
                </div>
            </Card>
        </>
    );
}

export default function CVCover(props) {
    const isNew = props.isNew || false
    const isActiveJHUser = props.isActiveJHUser || false

    const handleShowDatabase = () => {
        if (isActiveJHUser){
            JHApi.getFilesDBLink({},(response)=>{
                window.open(response, '_blank');
            }, (error) => {
                
            })
        }
    }

    const classes = PersonalJourneyClasses();

    return (
        <div>
            <Paper className={classes.prePublishSection} elevation={1} style={{marginTop:0, backgroundColor: isNew?'#edeafa':undefined}}>
                {isNew?<div style={{display: 'flex',justifyContent: 'space-between',alignItems: 'center'}}>
                    <div>
                        <Typography variant='h3' style={{color: '#1f2937', fontWeight: 500, fontSize: 18, lineHeight: '28px'}}>Database</Typography>
                        <Typography style={{color: '#4b5563', fontSize: 14, lineHeight: '20px'}}>Browse professional CV and cover letter templates and examples</Typography>
                    </div>
                    <CyanButton style={{textTransform: 'none', minWidth: 200}} color='primary' variant='contained' onClick={handleShowDatabase}>
                        <SearchIcon style={{marginLeft: -4, marginRight: 8}}/>
                        Browse Templates
                        {!isActiveJHUser && (<Chip
                            label="Pro"
                            size="small"
                            style={{
                                backgroundColor: '#FFD700',
                                color: '#000',
                                fontWeight: 600,
                                marginLeft: 8
                            }}
                        />)}
                    </CyanButton>
                </div>:
                <Typography> 
                    <a href="https://docs.google.com/spreadsheets/u/1/d/1iTkuEuUcDzJuOA32aJLvaAQbICZGgcsmnGEk4F8nqgA/edit#gid=0" target="_blank" rel="noopener noreferrer">קורות חיים ומכתב מקדים - דוגמאות</a>
                </Typography>}
                <div style={{display: 'flex', gap: 8, marginTop: 24, flexWrap: 'wrap'}}>
                    <Button href='https://chatgpt.com/g/g-69eb16f171488191b5624a6e71dc8a27-jobhunt-cv-summary-builder' target='_blank' color='primary' variant='outlined' size='small' startIcon={<SparklesIcon />} style={{textTransform: 'none'}}>CV Summary Builder</Button>
                    <Button href='https://chatgpt.com/g/g-69eb0903b28c8191a7b2a697c62e9ea5-jobhunt-rolematch-cv' target='_blank' color='primary' variant='outlined' size='small' startIcon={<SparklesIcon />} style={{textTransform: 'none'}}>Role Match CV</Button>
                    <Button href='https://chatgpt.com/g/g-69eafe6ad8d081919f00a0b9b5e5e024-us-resume-tailoring-assistant' target='_blank' color='primary' variant='outlined' size='small' startIcon={<SparklesIcon />} style={{textTransform: 'none'}}>US Resume Tailoring Assistant</Button>
                    <Button href='https://chatgpt.com/g/g-69ef28aabe2481918d27ef5ba5513e98-jobhunt-application-gap-checker' target='_blank' color='primary' variant='outlined' size='small' startIcon={<SparklesIcon />} style={{textTransform: 'none'}}>Application Gap Checker</Button>
                    
                </div>
            </Paper>

            {/*<AIAssistants/>*/}

            <Paper className={classes.prePublishSection} elevation={1} style={{marginTop:0}}>
                <CVManager {...props}/>
            </Paper>

            <Paper className={classes.prePublishSection} elevation={1} style={{marginTop:0}}>
                <CoverLetterManager {...props}/>
            </Paper>

            <Paper className={classes.prePublishSection} elevation={1} style={{marginTop:0}}>
                <OtherFiles {...props}/>
            </Paper>

            {!isNew&&<Paper className={classes.prePublishSection} elevation={1} style={{marginTop:0}}>
                <Typography dir="auto"> 
                    הסבר על גוגל דוקס:<br/><br/>
                    <a href="https://www.youtube.com/watch?v=-mE3-LhuAms" target='_blank' rel="noopener noreferrer">כיצד מעלים קובץ לדוקס</a><br/><br/>
                    <a href="https://www.youtube.com/watch?v=qRcu2_OEUqI" target='_blank' rel="noopener noreferrer">כיצד עושים שיתוף לקובץ</a>
                </Typography>
            </Paper>}

            {!isActiveJHUser&&<PricingCard/>}
        </div>
    )
}